import React, {useState, useEffect} from 'react'
import {getAll} from 'network/ApiAxiosReportsGetickets'
import NewEventReportSalesCard from "./NewEventReportSalesCard"
import {Container,Row,Col,Button } from "reactstrap";
import Header from 'components/Headers/Header';

import DatePicker from "react-datepicker";

function NewEventSales() {
    const [events, setEvents] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    
    const role = JSON.parse(localStorage.getItem('user')).role
    
    useEffect(() => {
        getEvents()
    }, [startDate]);

    const getEvents = async()=>{
        setEvents([])
        const response = await getAll('checkin',startDate)
        if(response.data.success){
          setEvents(response.data.result)
        }
    }

    const changePage = async(direction)=>{
      setEvents([])
      direction == 'next' ? setPage(page + 1) : setPage(page - 1)
      direction == 'next' ? getEvents(page + 1) : getEvents(page - 1)
    }


  return (
    <>
        {role == 'admin' && <Header/>}
        <Container fluid>
          <Row>
              <h2>Events Sales 7 days</h2>
          </Row>
          <Row>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd/MM/yyyy"
              className="form-control"
              placeholderText="Select a date"/>
          </Row>
          <Row className="mt-4">
              {events ? 
                events.map((event) =>{return (<NewEventReportSalesCard key={event._id} prodID={event._id} event={event} />)}) : 
                <Row className='justify-content-center'><Spinner color="primary" style={{height: '3rem',width: '3rem'}}>.</Spinner></Row>
              }
          </Row>
        </Container>
      </>
  )
}

export default NewEventSales